<template>
  <component
    :is="tag"
    class="pill"
    :data-c-tooltip="tooltipText"
    :class="[itemColor, {'full-sz': full}]"
    @click="clickPill"
  >
    <row class="component-row">
      <column class="row-title">
        <span>
          <icon v-if="hasIcon" :glyph="iconClass"></icon>
          {{ valueOrDefault }}
        </span>
      </column>

      <suffix class="d-flex">
        <slot name="suffix"></slot>

        <button v-if="hasEdit" @click="editPill" type="button" class="btn-icon clear edit">
          <icon class="pencil"></icon>
          <span class="sr-only">Edit Pill</span>
        </button>

        <button v-if="hasRemove" @click="removePill" type="button" class="btn-icon clear close">
          <icon class="times"></icon>
          <span class="sr-only">Remove Pill</span>
        </button>
      </suffix>
    </row>
  </component>
</template>

<script lang="ts">
  import Vue from "vue";
  import {EColor} from "~/enums/eColor";
  import {eColors} from "~/modules/gColors/colors";
  import {Logger} from "~/services/logger";
  import cTooltip from '~/modules/cTooltip/tooltipManager';

  export default Vue.extend({
    props: {
      color: {
        type: String,
        default: 'Blue',
      },
      full: {
        type: Boolean,
        default: false,
      },
      value: {
        type: String,
        default: ''
      },
      hasTooltip: {
        type: Boolean,
        default: false
      },
      tooltipValue: {
        type: String
      },
      iconClass:{
        type: String,
        default: ""
      },
      hasIcon:{
        type: Boolean,
        default: false
      },
      tag: {
        type: String,
        default: 'div'
      },
      placeholder: {
        type: String,
        default: ''
      },
    },
    data: function(){
      return {
        hasRemove: this.$listeners.onRemove,
        hasEdit: this.$listeners.onEdit,
        tooltipText: null,
        colors: [...eColors, 'ClearArea'],
        tooltip: new cTooltip().init()
      }
    },
    mounted() {
      if(this.hasTooltip || this.tooltipValue) {
        this.tooltipText = this.tooltipValue || this.valueOrDefault;
      }
    },
    methods: {
      clickPill($event) {
        this.$emit('onSelect', $event);
      },
      removePill($event){
        this.$emit('onRemove', $event);
      },
      editPill(){
        this.$emit('onEdit');
      },
      reloadTooltip(){
        this.tooltip = new cTooltip().init();
      },
    },
    computed: {
      itemColor: {
        get() {
          if(this.colors.includes(this.color)){
            return EColor[this.color];
          } else if(this.color === "") {
            return "";
          } else {
            Logger.errorOnce('Pill', `Color *${this.color}* not available for the pill.`, 'Try one of these values instead:', this.colors);
            return "color-unavailable";
          }
        },
        set() {},
      },
      
      valueOrDefault(): string {
        return this.value || this.placeholder;
      }
    },
    updated(){
      this.reloadTooltip();
    },
    beforeDestroy(){
      if (this.tooltip !== undefined) {
        this.tooltip.deleteTooltipContainer();
      }
    }
  });
</script>
